const commonConfig = {
  loaderColor: '#E99041',
  path: {
    auth: '/auth',
    dashboard: '/',
    login: '/login',
  }
}
export default commonConfig;
